// @flow

import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { Error404 } from './errors';

import { Provider} from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import promise from 'redux-promise';
import reducers from './reducers';
import Auth from './auth/auth';
import axios from 'axios';

import DashboardPage from './dashboard/dashboard.react';
import { RequisitionPage, RequisitionFormPage, RequisitionItemPage, RequisitionItemFormPage, RequisitionReportPage } from './requisition';
import { UserPage, UserFormPage } from './user';
import { RolePage, RoleFormPage } from './role';
import { DepartmentPage, DepartmentFormPage } from './department';
import CallbackPage from './callback/callback.react';

import 'bootstrap';
import 'tabler-react/dist/Tabler.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'

const authProps = { clientId: process.env.REACT_APP_AUTH_CLIENTID, redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI };
const auth = new Auth(authProps);

const handleAuthentication = (nextState, replace) => {
  if (/access_token|error/.test(nextState.location.hash)) {
    auth.handleAuthentication();
  }
};

const PrivateRoute = ({ component: Component, module, action, ...rest }) => (
  <Route {...rest} component={(props) => {
    if(auth.isAuthenticated()) {
      if (!module || !action) return ( <Component {...props} /> );
      if (auth.hasAccess(module, action) && auth.validateIntranet(module)) return ( <Component {...props} /> );
      return ( <Redirect to="/" /> );
    }
    else {
      localStorage.setItem('redirectUri', rest.location.pathname);
      auth.logout();
      return null;
    }
  }} />
);

(function() {
     var token = auth.getAccessToken();
     if (token) {
         axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
     } else {
         axios.defaults.headers.common['Authorization'] = null;
         /*if setting null does not remove `Authorization` header then try
           delete axios.defaults.headers.common['Authorization'];
         */
     }
})();

const createStoreWithMiddleware = applyMiddleware(promise)(createStore);

const App = () => {
  return (
    <Provider store={createStoreWithMiddleware(reducers)}>
      <Router basename={process.env.PUBLIC_URL}>
        <LastLocationProvider>
        <Switch>
          <PrivateRoute exact path='/' component={DashboardPage} />
          <PrivateRoute exact module="request" action="read" path="/requisition/mine" component={RequisitionPage} />
          <PrivateRoute exact module="request" action="read" path="/requisition/assigned" component={RequisitionItemPage} />
          <PrivateRoute exact module="request" action="read" path="/requisition/all" component={RequisitionItemPage} />
          <PrivateRoute exact module="request" action="read" path="/requisition/view-only" component={RequisitionItemPage} />
          <PrivateRoute exact module="request" action="create" path="/requisition/new" component={RequisitionFormPage} />
          <PrivateRoute exact module="request" action="read" path="/requisition/report" component={RequisitionReportPage} />
          <PrivateRoute exact module="request" action="read" path="/requisition/:id" component={RequisitionFormPage} />
          <PrivateRoute exact module="request" action="read" path="/requisition/item/:id" component={RequisitionItemFormPage} />
          <PrivateRoute exact module="user" action="read" path="/users" component={UserPage} />
          <PrivateRoute exact module="user" action="create" path="/users/new" component={UserFormPage} />
          <PrivateRoute exact module="user" action="read" path="/users/:id" component={UserFormPage} />
          <PrivateRoute exact module="role" action="read" path="/roles" component={RolePage} />
          <PrivateRoute exact module="role" action="create" path="/roles/new" component={RoleFormPage} />
          <PrivateRoute exact module="role" action="read" path="/roles/:id" component={RoleFormPage} />
          <PrivateRoute exact module="department" action="read" path="/departments" component={DepartmentPage} />
          <PrivateRoute exact module="department" action="create" path="/departments/new" component={DepartmentFormPage} />
          <PrivateRoute exact module="department" action="read" path="/departments/:id" component={DepartmentFormPage} />
          <Route exact path="/logout" component={() => {
              auth.logout();
              return null;
          }} />
          <Route exact path="/callback" component={(props) => {
              handleAuthentication(props);
              return <CallbackPage {...props} />
          }} />
          <Route component={Error404} />
        </Switch>
        </LastLocationProvider>
      </Router>
    </Provider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.react.js